import type { Point } from '../../hex/types';

/**
 * Draws shoreline foam along a single hex edge.
 * Used to blend water/coast tiles with adjacent land.
 */
export function drawFoamAlongEdge(
    ctx: CanvasRenderingContext2D,
    a: Point,
    b: Point,
    inward: Point,
    rng: () => number,
    zoom: number,
): void {
    const steps = 5 + Math.floor(rng() * 5);
    const inset = (2.2 + rng() * 2.0) / zoom;
    const jitter = (1.0 + rng() * 1.6) / zoom;

    ctx.save();
    ctx.globalCompositeOperation = 'screen';
    ctx.strokeStyle = 'rgba(255,255,255,0.22)';
    ctx.lineWidth = (1.3 + rng() * 0.6) / zoom;

    for (let i = 0; i < steps; i += 1) {
        const t0 = i / steps + rng() * 0.02;
        const t1 = (i + 1) / steps - rng() * 0.02;

        const p0 = { x: a.x + (b.x - a.x) * t0, y: a.y + (b.y - a.y) * t0 };
        const p1 = { x: a.x + (b.x - a.x) * t1, y: a.y + (b.y - a.y) * t1 };

        const mid = { x: (p0.x + p1.x) * 0.5, y: (p0.y + p1.y) * 0.5 };
        const ctrl = {
            x: mid.x + inward.x * inset + (rng() - 0.5) * jitter,
            y: mid.y + inward.y * inset + (rng() - 0.5) * jitter,
        };

        ctx.beginPath();
        ctx.moveTo(p0.x + inward.x * inset, p0.y + inward.y * inset);
        ctx.quadraticCurveTo(ctrl.x, ctrl.y, p1.x + inward.x * inset, p1.y + inward.y * inset);
        ctx.stroke();
    }

    ctx.restore();
}
